<template>
    <div class="content">
        <app-header :module-navigation="navigation" module-name="Facturation"></app-header>
        <main id="page-main" class="with-tabs">
            <router-view></router-view>
        </main>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                navigation: [
                    {
                        route: 'invoicing-dashboard',
                        label: 'Dashboard',
                        acl: null
                    },
                    {
                        route: 'invoice',
                        label: 'Factures',
                        acl: 'weeboxcore.invoice.view'
                    }
                ]
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/invoicing/Index.vue